
 const renderPatternDetection = (data) => (
    <div className="pattern-detection">
      <div className="analysis-header bg-gradient-to-r from-primary/20 to-accent/20 p-6 rounded-lg border border-primary/30 mb-6">
        <h3 className="text-xl font-bold text-primary mb-2 flex items-center">
          🔍 Behavioral Pattern Analysis
        </h3>
        <p className="text-foreground">{data.analysis}</p>
      </div>

      {data.patterns && data.patterns.length > 0 && (
        <div className="patterns-grid space-y-4">
          {data.patterns.map((pattern, index) => (
            <div key={index} className={`pattern-card p-6 rounded-lg border-l-4 bg-card ${
              pattern.severity === 'high' ? 'border-destructive' :
              pattern.severity === 'medium' ? 'border-yellow-500' :
              'border-primary'
            }`}>
              <div className="flex justify-between items-start mb-3">
                <h4 className="text-lg font-semibold text-foreground">{pattern.title}</h4>
                <span className={`px-3 py-1 text-xs font-medium rounded-full ${
                  pattern.severity === 'high' ? 'bg-destructive/20 text-destructive' :
                  pattern.severity === 'medium' ? 'bg-yellow-500/20 text-yellow-500' :
                  'bg-primary/20 text-primary'
                }`}>
                  {pattern.severity} priority
                </span>
              </div>

              <p className="text-card-foreground mb-3">{pattern.description}</p>

              {pattern.evidence && (
                <div className="mb-3">
                  <strong className="text-sm text-muted-foreground">Evidence:</strong>
                  <p className="text-sm text-muted-foreground mt-1">{pattern.evidence}</p>
                </div>
              )}

              <div className="recommendation bg-secondary p-3 rounded border border-border">
                <strong className="text-sm text-primary">💡 Recommendation:</strong>
                <p className="text-sm text-secondary-foreground mt-1">{pattern.recommendation}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  export default renderPatternDetection;